import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import {
  customEmailProviderSchema,
  customEmailSenderSchema,
} from "./custom-email-sender";

export const setCustomEmailSenderProvider = {
  name: "setCustomEmailSenderProvider" as const,
  input: z.object({
    teamId: zExt.objectId(),
    integrationId: z.string().min(1),
    provider: customEmailProviderSchema,
  }),
  output: z.object({ sender: customEmailSenderSchema }),
};
